<template>
    <v-dialog max-width="600" v-model="changeNameDialog" persistent>
        <v-card>
            <v-card-title class="primary white--text"
                ><v-icon color="white" class="mr-2">edit</v-icon>Edit Folder
                Name</v-card-title
            >
            <v-card-text>
                <v-text-field
                    v-bind:value="parentSelectedValue"
                    @input="$emit('update:parentSelectedValue', $event)"
                >
                    dense label="Choose New Name" class="mt-9" required
                    ></v-text-field
                >
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn text @click="$emit('closeChangeFolderNameDialog')">
                    Close
                </v-btn>
                <v-btn
                    color="primary"
                    rounded
                    outlined
                    dense
                    @click="changeNameMutation"
                    :loading="isLoadingNameChange"
                    >Save</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import gql from "graphql-tag";
export default {
    name: "ChangeFolderNameDialog",
    props: ["changeNameDialog", "targetFolderID", "parentSelectedValue"],
    data() {
        return {
            // inputNewFolderName: "Default",
            isLoadingNameChange: false
        };
    },
    methods: {
        changeNameMutation() {
            this.isLoadingNameChange = true;
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation Mutation($input: UpdatePlanFolderInput!) {
                            updatePlanFolder(input: $input) {
                                planFolder {
                                    id
                                    name
                                }
                            }
                        }
                    `,
                    variables: {
                        input: {
                            id: this.targetFolderID,
                            name: this.parentSelectedValue
                        }
                    }
                })
                .then(response => {
                    this.$emit(
                        "planFolderNameChanged",
                        response.data.updatePlanFolder.planFolder
                    );
                })
                .finally(() => {
                    this.isLoadingNameChange = false;
                    // this.inputNewFolderName = "";
                    this.$emit("closeChangeFolderNameDialog");
                });
        }
    },
    watch: {}
};
</script>